import MediaLibrary from "@/admin/MediaLibrary";

export default function MediaPage() {
  return <MediaLibrary />;
}
